var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Link, StyledDropdown, StyledDropdownMenu, Container } from './style';
import { ActLinksMenu } from './ActLinksMenu';
export var MenuLink = function (props) {
    var content = props.content, width = props.width;
    return (React.createElement(StyledDropdown, { item: true, icon: false, upward: false, trigger: React.createElement(Link, null, content) },
        React.createElement(StyledDropdownMenu, null,
            React.createElement(Container, { "$maxWidth": width },
                React.createElement(ActLinksMenu, __assign({}, props))))));
};
//# sourceMappingURL=MenuLink.js.map